import { useSession } from "../lib/session";

/** Logged-in subject badge. Reads the session the provider already resolved. */
export default function IdentityBadge() {
  const { subject, grants } = useSession();
  if (!subject) return null;
  return (
    <div
      className="text-xs text-kw-text-muted truncate"
      title={`${subject} · ${grants.scopes.join(" ")}`}
    >
      <span className="text-kw-text-faint">subject</span> {subject}
    </div>
  );
}
